const requireModule = require.context('.', true, /\.vue$/)
const modules = {}

requireModule
  .keys()
  .map(fileName => {
    if (fileName.endsWith('index.js')) return
    return {
      target: requireModule(fileName),
      name: fileName.replace(/(\.\/|\.vue)/g, ''),
    }
  })
  .sort((a, b) => a.target.meta.order - b.target.meta.order)
  .forEach(entry => {
    modules['Residential' + entry.name] = entry.target.default
  })

export default modules
